module.exports = __webpack_public_path__ + "screenshot.81da17cc91405e3b7afdf0fa7d79676e.png";